import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetQuickNotesList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/QuickNotes/GetList?` + params, null);

export const GetQuickNotesDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/QuickNotes/GetDetail?` + params, null);  

export const CreateQuickNotes = (data: any) =>
  POST_ENC(`${BASE_URL}/api/QuickNotes/Create`, data);

export const UpdateQuickNotes = (data: any) =>
  POST_ENC(`${BASE_URL}/api/QuickNotes/Update`, data);

export const DeleteQuickNotes = (data: any) =>
  POST_ENC(`${BASE_URL}/api/QuickNotes/Delete`, data);